import { useTranslation } from "react-i18next";

import { HandlingUnitItemFragment } from "../../../../../../../models/autogenerated-deliveryService-gql/graphql";
import "./DetailsPopoverItem.scss";
import DetailsPopoverItemProperty from "./detailsPopoverItemsProperty/DetailsPopoverItemProperty";

interface DetailsPopoverItemHandlingUnitProps {
  item: HandlingUnitItemFragment;
}

const DetailsPopoverItemHandlingUnit = (
  props: DetailsPopoverItemHandlingUnitProps,
) => {
  const { t } = useTranslation();
  const { item } = props;

  return (
    <div className="details-item-container" key={item.id}>
      <DetailsPopoverItemProperty
        label={t("huName")}
        value={`${item.huTypeResolved?.name} ${item.huTypeResolved?.description && `(${item.huTypeResolved?.description})`} `}
      />
      <DetailsPopoverItemProperty label={t("huId")} value={item.id} />
      <DetailsPopoverItemProperty label={t("position")} value={item.number} />
      <DetailsPopoverItemProperty
        label={t("owner")}
        value={item.ownerResolved?.name}
      />
      <DetailsPopoverItemProperty
        label={t("stockType")}
        value={item.stockTypeResolved?.longName}
      />
      <DetailsPopoverItemProperty
        label={t("stockTypeId")}
        value={item.stockTypeResolved?.id}
      />
      <div className="page-content-divider" />
    </div>
  );
};

export default DetailsPopoverItemHandlingUnit;
